import React from "react";
import { formFieldDefs } from "./10formFields";
import "./10Variable.css";

const VIP10Variable = () => {
  // 요약 정보 계산
  const totalVars = formFieldDefs.length;
  const conditionVars = formFieldDefs.filter((f) => f.conditions).length;

  // 조건 객체/문자열을 사람이 읽기 쉬운 형태로 변환
  const formatCond = (cond) => {
    if (!cond) return "-";
    if (typeof cond === "string") {
      return cond
        .replace(/===/g, "=")
        .replace(/!==/g, "≠")
        .replace(/ includes /g, " ∋ ")
        .replace(/"/g, "");
    }
    if (Array.isArray(cond)) {
      return cond.map(formatCond).join(" AND ");
    }
    if (typeof cond === "object" && cond.or) {
      return cond.or.map(formatCond).join(" OR ");
    }
    try {
      return JSON.stringify(cond);
    } catch (e) {
      return String(cond);
    }
  };

  return (
    <div className="vip-variable-container">
      {/* 변수 정보 요약 섹션 */}
      <div className="variable-summary">
        <h2 className="summary-title">변수 정보 요약</h2>
        <div className="summary-cards">
          <div className="summary-card">
            <span className="summary-value">{totalVars}</span>
            <span className="summary-label">전체 변수</span>
          </div>
          <div className="summary-card">
            <span className="summary-value">{conditionVars}</span>
            <span className="summary-label">커스텀 변수</span>
          </div>
        </div>
      </div>

      <div className="variable-note">
        <p>구현된 필드의 Field ID 및 Label 정보입니다.</p>
        <p>데이터 분석을 위한 변수의 타입 설정이 매핑되어 있습니다.</p>
        <p>
          설계 정보 변경이 필요하거나, 문의가 있을 시에는{" "}
          <strong>문의 탭</strong>을 이용해주세요.
        </p>
      </div>

      <h3 className="type-section-title">지원되는 데이터 타입</h3>
      <p className="type-section-desc">
        현재 데이터 분석을 위해 지정할 수 있는 Type의 종류는 다음과 같습니다.
        (괄호 안은 R / Python&nbsp;Pandas에서 사용되는 대표적인 자료형입니다)
      </p>

      <table className="variable-table">
        <thead>
          <tr>
            <th>Type 이름</th>
            <th>R 자료형</th>
            <th>Python dtype</th>
            <th>Encoding 예시</th>
          </tr>
        </thead>
        <tbody>
          {[
            {
              type: "text",
              r: "character",
              py: "object (string)",
              enc: "'남', '여' / 'M', 'F'",
            },
            {
              type: "number",
              r: "numeric / integer",
              py: "float64 / int64",
              enc: "1, 2, 3 … (연속형)",
            },
            {
              type: "categorical",
              r: "factor",
              py: "category",
              enc: "1=남, 0=여 등",
            },
            {
              type: "ordinal",
              r: "ordered factor",
              py: "CategoricalDtype(ordered=True)",
              enc: "Likert 1~5",
            },
            {
              type: "boolean",
              r: "logical",
              py: "bool",
              enc: "TRUE / FALSE, 1 / 0",
            },
            {
              type: "date",
              r: "Date",
              py: "datetime64[ns] (date) ",
              enc: "YYYY-MM-DD",
            },
            {
              type: "datetime",
              r: "POSIXct / POSIXlt",
              py: "datetime64[ns]",
              enc: "YYYY-MM-DD HH:MM",
            },
            {
              type: "time",
              r: "hms / difftime",
              py: "timedelta64[ns]",
              enc: "HH:MM:SS",
            },
          ].map((row) => (
            <tr key={row.type}>
              <td>{row.type}</td>
              <td>{row.r}</td>
              <td>{row.py}</td>
              <td>{row.enc}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="table-wrapper" style={{ marginTop: "24px" }}>
        <table className="variable-table">
          <thead>
            <tr>
              <th>Field ID</th>
              <th>Label</th>
              <th>Type</th>
              <th>Unit</th>
              <th>Options</th>
              <th>Conditions</th>
            </tr>
          </thead>
          <tbody>
            {formFieldDefs.map((field) => {
              const options = field.options
                ? Array.isArray(field.options)
                  ? field.options.map((o) => o.label).join(", ")
                  : Object.values(field.options).join(", ")
                : "-";
              const condText = formatCond(field.conditions);
              return (
                <tr key={field.id}>
                  <td>{field.id}</td>
                  <td>{field.label}</td>
                  <td>{field.type}</td>
                  <td>{field.unit || "-"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{options}</td>
                  <td style={{ whiteSpace: "nowrap" }}>{condText}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VIP10Variable;
